var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"header-tile",class:`text-${_vm.textAlign} ${_vm.className}`,domProps:{"innerHTML":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }